import { HTMLAttributes } from 'react';

import { UnderlineIcon } from '@radix-ui/react-icons';
import { useEditorState, type Editor } from '@tiptap/react';

import { Toggle } from '../../../primitives/toggle';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../../primitives/tooltip';

interface ToggleUnderlineProps extends Pick<HTMLAttributes<HTMLDivElement>, 'className'> {
  editor: Editor;
}

export function ToggleUnderline({ className, editor }: ToggleUnderlineProps) {
  const { isUnderline } = useEditorState({
    editor,
    selector: ({ editor }: { editor: Editor }) => ({
      isUnderline: editor.isActive('underline'),
    }),
  });

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div>
          <Toggle
            aria-label="Subrayado"
            className={className}
            disabled={!editor.isEditable}
            pressed={isUnderline}
            size="icon"
            variant="ghost"
            onPressedChange={() => editor.chain().focus().toggleUnderline().run()}
          >
            <UnderlineIcon className="size-4" />
          </Toggle>
        </div>
      </TooltipTrigger>
      <TooltipContent>
        <p className="flex flex-col">
          Subrayado <span className="text-accent">⌘U</span>
        </p>
      </TooltipContent>
    </Tooltip>
  );
}
